export interface AppConfig {
  apiUrl: string;
  cognitoDomain: string;
  cognitoClientId: string;
  redirectUri: string;
  logoutUri: string;
}

let config: AppConfig | undefined;

/**
 * Loads /config.json, written by the CDK deployment (or copied from config.example.json
 * for local development), so one build works against any stack.
 */
export async function loadConfig(): Promise<AppConfig> {
  if (config) return config;
  const response = await fetch('/config.json', { cache: 'no-store' });
  if (!response.ok) throw new Error('Missing /config.json. Copy public/config.example.json to public/config.json.');
  config = (await response.json()) as AppConfig;
  return config;
}

export function getConfig(): AppConfig {
  if (!config) throw new Error('Config not loaded');
  return config;
}
